import { DepartureCard, TripInfoCard } from '@/root/modules/shared/SelectTicketPage'
import { Divider } from '@/root/ui/shared'
import { VoyageInfo } from '@/root/shared-types'

interface DepartureAndTripInfoProps {
  routeInfo: VoyageInfo
  timestamp: string
  showDivider?: boolean
}

export const DepartureAndTripInfo = ({ routeInfo, timestamp, showDivider = false }: DepartureAndTripInfoProps) => {
  return (
    <>
      {showDivider && (
        <div className="relative my-6 w-full">
          <Divider variant={'light'} />
        </div>
      )}
      <DepartureCard timestamp={timestamp} />
      <TripInfoCard routeInfo={routeInfo} />
    </>
  )
}
